<div
    [attr.role]="'tablist'"
    class="product-image-gallery-container"
    @noopAnimation
    [attr.aria-labelledby]="prefixTab + '-image-gallery'"
    [attr.aria-orientation]="'vertical'">
    @for (asset of product?.assets; track trackByAsset(idx, asset); let idx = $index) { @if (idx < maxVisibleImages ||
    remainingImages === 1) {

    <button
        [attr.role]="'tab'"
        tabindex="{{ idx === currentIndex ? 0 : -1 }}"
        [attr.aria-selected]="idx === currentIndex ? 'true' : 'false'"
        [attr.aria-controls]="prefixerAriaControls(idx)"
        id="{{ prefixTab }}{{ idx }}"
        class="image-gallery-item"
        [ngClass]="{ 'background-white': isPersoProduct }"
        (click)="switchImage(idx)"
        (keyup)="handleThumbnailSelectedWithKey($event, idx)">
        <!-- in the case of beltkits we format the urls with beltkitSeoImgSrc -->
        <ng-container
            *ngTemplateOutlet="
                simple;
                context: { $implicit: asset, imageUrl: asset.type === 'video' ? asset.posterUrl : asset.url }
            ">
        </ng-container>

        <ng-template #simple let-imageUrl="imageUrl">
            <img
                @fadingAnimation
                hI18nAsset
                [tag]="asset.tag"
                [imageTitle]="product.title"
                [url]="asset.url"
                [hI18nAttr]="'alt'"
                class="gallery-img"
                [ngClass]="{ checked: idx === currentIndex }"
                alt=""
                [attr.srcset]="
                            imageUrl
                                | productImageSeoUrl
                                    : {
                                          slug: product.slug,
                                          imageSize: thumbnailSize,
                                          srcSet: true,
                                          templateType: product.templateType,
                                      }
                        "
                [attr.src]="
                            imageUrl
                                | productImageSeoUrl
                                    : {
                                          slug: product.slug,
                                          imageSize: thumbnailSize,
                                          templateType: product.templateType,
                                      }
                        " />

            @if (asset.type === 'video') {
            <span class="play-icon">
                <h-svg-icon [name]="'play-media'"></h-svg-icon>
            </span>
            }
        </ng-template>
    </button>

    } }
</div>
